// Public entry point for the site assistant. The rest of the app imports from
// here so the underlying provider (local KB today, Nova Sonic / Lex later) can
// change without touching the UI.

import type { AssistantProvider } from './types'
import { ResilientTextProvider } from './bedrockProvider'

export type { AssistantProvider, AssistantReply, AssistantAction, ChatMessage } from './types'
export { executeAction } from './actionExecutor'
export type { ExecuteOptions } from './actionExecutor'
export { VoiceClient, isVoiceSupported } from './voiceClient'
export type { VoiceState, VoiceClientHandlers } from './voiceClient'
export { speak, stopSpeaking, subscribeVoiceLevel } from './pollyVoice'
export { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE, isRtl } from './languages'
export type { AssistantLanguage } from './languages'

/**
 * Build the text provider. Typed messages go to the Bedrock Converse brain on
 * the server for smart, tool-using answers, and gracefully fall back to the
 * local knowledge base if the server is unavailable. Voice is handled separately
 * by Nova Sonic over a WebSocket.
 */
export function createTextProvider(): AssistantProvider {
  return new ResilientTextProvider()
}
